import React from "react";
import {
  Text,
  View,
  TouchableOpacity,
  Image,
  ImageBackground,
  Pressable,
  Platform,
} from "react-native";
import { isGradientAllowed, ScreenNameList } from "@lib/utilities/Constants";
import { BRANDING_BACKGROUND_IMAGE, LOGO } from "../../resources/IMAGES";
import CommonStyle from "../../assets/styles/common-style";
import NavigationBar from "../../components/navigationBar/NavigationBar";
import Rightpanel from "../../components/rightPanel/Rightpanel";
import ActivityIndicatorLoader from "../../components/common/ActivityIndicatorLoader";
import CustomAlert from "../../components/common/CustomAlert";
import { ids, styles } from "./Style";
import { useForgotPassword } from "@lib/hooks/passwords/useForgotPassword";
import commonStyle from "../../assets/styles/common-style";
import { description, messages } from "../../resources/strings";
import GradientBackground from "../../components/gradient-background/GradientBackground";

const ForgotPassword = ({ route, navigation }: any) => {
  const {
    isLoading,
    errorHandle,
    isEmailSent,
    heading,
    btnLabel,
    isModalVisible,
    email,
    resetPasswordAction,
    homeAction,
    toggleModal,
    showInternetalert,
    handleInvalidTokenCase,
    setErrorHandle,
  } = useForgotPassword(navigation, route);

  const Content = () => (
    <>
      <View style={{ zIndex: 999 }}>
        <NavigationBar
          data={{
            screenName: isEmailSent
              ? ScreenNameList.regsiterSuccessView
              : ScreenNameList.forgotPassword,
          }}
          barNavigation={navigation}
          onProfilePress={() => {
            toggleModal();
          }}
        />

        <Rightpanel
          onNoInternet={async () => {
            await showInternetalert();
          }}
          closeRightPanel={toggleModal}
          toggleModal={toggleModal}
          isModalVisible={isModalVisible}
          navigation={navigation}
          screenName={ScreenNameList.forgotPassword}
        />
      </View>
      <View
        style={[styles.container, CommonStyle.styles.inMiddle]}
        dataSet={{ media: ids.container }}
      >
        <View
          style={[styles.registerContainer, CommonStyle.styles.inMiddle]}
          dataSet={{ media: ids.registerContainer }}
        >
          <View
            style={[styles.loginSuccess]}
            dataSet={{ media: ids.loginSuccess }}
          >
            <View style={[styles.logoBlock]} dataSet={{ media: ids.logoBlock }}>
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO}
              />
            </View>
            <View style={[styles.heading]} dataSet={{ media: ids.heading }}>
              <Text
                style={[styles.headingText]}
                dataSet={{ media: ids.headingText }}
              >
                {heading}
              </Text>
            </View>

            <View style={{ marginTop: 16 }}>
              {isEmailSent && (
                <View style={{ display: "flex" }}>
                  <Text
                    style={[styles.whiteTextSmall]}
                    dataSet={{ media: ids.whiteTextSmall }}
                  >
                    We've just emailed instructions and reset password link to{" "}
                    <Text
                      style={[styles.textBold]}
                      dataSet={{ media: ids.textBold }}
                    >
                      {email}
                    </Text>
                  </Text>
                </View>
              )}
              {!isEmailSent && (
                <View style={{ display: "flex" }}>
                  <Text
                    style={[styles.whiteTextSmall]}
                    dataSet={{ media: ids.whiteTextSmall }}
                  >
                    {description.forgotPassword.description1}
                    <Text
                      style={[styles.textBold]}
                      dataSet={{ media: ids.textBold }}
                    >
                      {email}
                    </Text>{" "}
                    with instructions on how to reset the password.
                  </Text>
                </View>
              )}
            </View>

            <Pressable
              style={[styles.submitButton]}
              dataSet={{ media: ids.submitButton }}
              onPress={() => {
                isEmailSent ? homeAction() : resetPasswordAction();
              }}
            >
              <Text style={[styles.btnText]} dataSet={{ media: ids.btnText }}>
                {btnLabel}
              </Text>
            </Pressable>
            {!isEmailSent && (
              <TouchableOpacity
                onPress={() => {
                  navigation.goBack();
                }}
              >
                <Text
                  style={[styles.loginLink]}
                  dataSet={{ media: ids.loginLink }}
                >
                  Back
                </Text>
              </TouchableOpacity>
            )}
          </View>
        </View>
      </View>
      {isLoading && (
        <View style={styles.loader} dataSet={{ media: ids.loader }}>
          <ActivityIndicatorLoader
            data={{ screenName: ScreenNameList.forgotPassword }}
            indicator={true}
          />
        </View>
      )}
      {errorHandle != messages.error.noError ? (
        <View style={commonStyle.styles.errorView}>
          <CustomAlert
            data={{
              message: errorHandle,
              screenName: ScreenNameList.forgotPassword,
            }}
            onEndTimer={() => {
              setErrorHandle(messages.error.noError);
            }}
            onEndLogoutTimer={() => {
              handleInvalidTokenCase();
            }}
          />
        </View>
      ) : null}
    </>
  );

  if (isGradientAllowed && Platform.OS !== "web") {
    return (
      <GradientBackground styles={CommonStyle.styles.coverImage}>
        <Content />
      </GradientBackground>
    );
  }
  return (
    <ImageBackground
      source={BRANDING_BACKGROUND_IMAGE}
      style={[
        CommonStyle.styles.coverImage,
        isGradientAllowed && styles.gradientBg,
      ]}
      imageStyle={{
        resizeMode: "cover",
        top: 0,
      }}
    >
      <Content />
    </ImageBackground>
  );
};

export default ForgotPassword;
